import { toStringArr } from 'stores/security';
import type { CustomerInfoKeyType } from 'types/customer';
import type { OptionItem } from '.';

/**
 * 将旧版的选项转换为新的格式，确保value是类型是正确的
 * @description 旧版的FormSelect组件基于原生select，会将number类型的选项value强制转换为string类型
 * @param options 选项列表数组
 * @param field 该选项的字段名称，在toStringArr中定义的字段会将value转换为string类型
 */
export function transformLegacyOptions<T = string[] | OptionItem[]>(
    options: T[],
    field: CustomerInfoKeyType,
    configOptions?: {
        labelName?: string;
        valueName?: string;
    }
): OptionItem[] {
    const { labelName = 'label', valueName = 'value' } = configOptions || {};

    return options.map((item, index) => {
        if (typeof item === 'string') {
            return {
                label: item,
                value: toStringArr.includes(field) ? String(index) : index
            };
        }

        return {
            label: item[labelName],
            value: toStringArr.includes(field) ? String(item[valueName]) : item[valueName]
        };
    });
}
